import { Nugget } from '../../../navigation/Nugget';
import { DisplayHeading } from '../../../typography/DisplayHeading';

export type HeroTitleProps = {
  className?: string;
  title: string;
  //@TODO: Refactor this when piping
  // DI for this function as it lies in web app utils, and we won't make any side effects on that nor rely on web app.
  slugToName?: (categoryName: string) => string;
  category: {
    categoryName: string;
    href: string;
  };
};

export const HeroTitle = ({
  className,
  title,
  slugToName = (categoryName) => categoryName,
  category: { categoryName },
}: HeroTitleProps) => {
  return (
    <div className={className}>
      {categoryName && (
        <Nugget
          className="text-neutral-strong rounded px-1 py-0.5 text-xs font-semibold uppercase leading-none tracking-wide"
          testId="category-link"
        >
          {slugToName(categoryName)}
        </Nugget>
      )}
      <DisplayHeading
        size="6"
        as="h1"
        leading="snug"
        className="text-neutral-strong my-2 text-xl font-semibold tracking-tight md:text-2xl md:leading-snug"
        data-testid="title"
      >
        {title}
      </DisplayHeading>
    </div>
  );
};
